import React from "react";
import Cookies from 'universal-cookie';
import history from '../../../history';
import './footer.css'

export default function footer(props){
  const cookies = new Cookies();
  let industryCookie = cookies.get('industry') ? cookies.get('industry') : ""

  /* istanbul ignore next */
  switch (cookies.get('industry')) {
    case 'real_estate_agencies_and_valuers':
      industryCookie = 'realEstate'
      break;
    case 'mortgage_brokers_and_financial_planners':
      industryCookie = 'mortgageFinance'
      break;
    case 'investors':
      industryCookie = 'investors'
      break;
    case 'property_developers_trades_services':
      industryCookie = 'trades'
      break;
    default:
      industryCookie = ''
      break;
  }

  return(
    <React.Fragment>
      <div className={
              props.currentStep != 4
                ? 'wizard-form-footer'
                : 'wizard-form-footer margin-left-neg15'
            } >
        <span
          className="text-link"
          onClick={() => {
            props.trackStep("Back to packages", props.currentStep)
            props.trackStepResponse(props.currentStep, props.inputValues)
            if (props.method && industryCookie) {
              history.push("/product/"+props.FRIENDLY_NAME+"?industry="+industryCookie+"&method="+props.method)
            } else if (props.method && !industryCookie) {
              history.push("/product/"+props.FRIENDLY_NAME+"?method="+props.method)
            } else if (!props.method && industryCookie) {
              history.push("/product/"+props.FRIENDLY_NAME+"?industry="+industryCookie)
            } else {
              history.push("/product/"+props.FRIENDLY_NAME)
            }
          }}>
          Back to all packages and pricing
        </span>
        {
          props.currentStep === 4 &&
          <span className="wizard-help body">
            Need help? Call us on 1300 734 318
          </span>
        }
        <br/>
        {
          props.currentStep !== 4 &&
          <span className="wizard-policy footnote-text">
            By completing this form you acknowledge that you have read our <a className="text-link"target="_blank" rel="noopener noreferrer" href="https://www.cotality.com/au/legal/privacy">Privacy Policy</a> which summarises how we use, collect and disclose your personal information.
          </span>
        }
        {
          props.currentStep === 4 &&
          <span className="wizard-policy footnote-text">
            • * Whilst you’ve told us a little about your business, we do not know your business like you do. Although we have recommended the package we believe will best meet your needs based on the information we have, we do not warrant that the package will meet all of your business requirements, or is suitable for every or any particular intended use.
            <br/>
            • By completing this form you acknowledge that you have read our <a className="text-link " target="_blank" rel="noopener noreferrer" href="https://www.cotality.com/au/legal/privacy">Privacy Policy</a> which summarises how we use, collect and disclose your personal information.
          </span>
        }

      </div>
    </React.Fragment>
  )
}
